import React from 'react'
import ReferenceSheetProvider, {
  useReferenceSheet,
} from './ReferenceSheetProvider'
import { TemplateProvider } from '../../lib/pdf'
import { TranslationProvider } from '~/components/shared/TranslationProvider'
import translations from './locales.json'
import { templates, templateStyle, templateSupportedStyles } from './templates'
import { useTranslation } from '~/hooks/useTranslation'

const StandaloneViewer = ({ locale, ...props }) => {
  const { template_settings, template_index } = props
  const defaultStyle = template_settings
    ? {
        ...templateStyle,
        [`template-${template_index}`]: template_settings,
      }
    : templateStyle
  const templateProps = {
    templates,
    defaultStyle,
    templateSupportedStyles,
    template_index,
  }

  return (
    <TranslationProvider
      locale={locale}
      translations={translations}
      scope="javascript.components.ReferenceSheetBuilder"
    >
      <TemplateProvider {...templateProps}>
        <ReferenceSheetProvider locale={locale} {...props}>
          <div id="resume-pdf-preview" className="relative md:flex-grow">
            <div className="w-full md:sticky md:left-0 md:top-0 md:h-screen">
              <PdfViewer {...props} />
            </div>
          </div>
        </ReferenceSheetProvider>
      </TemplateProvider>
    </TranslationProvider>
  )
}
export default StandaloneViewer

const PdfViewer = () => {
  const { t } = useTranslation('ReferenceItem')
  const {
    pdf: { url, loading },
  } = useReferenceSheet()

  if (loading) {
    return null
  }
  return (
    <iframe
      src={`${url}#navpanes=0`}
      className="h-full w-full"
      title={t('resume_preview')}
      frameBorder="0"
      loading="lazy"
    />
  )
}
